import * as yup from 'yup';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { firestore } from 'services';

import { strings } from '../strings';

export enum UploadCollectionField {
  Name = 'name',
  Keywords = 'keywords',
  AdminOnly = 'adminOnly',
  Type = 'type',
}

export enum CollectionType {
  Puzzle = 'puzzle',
  ColoringGrid = 'coloring-grid',
}

// matches(/[a-zA-Z 0-9]*/, "").

export const uploadCollectionShema = yup.object().shape({
  [UploadCollectionField.Type]: yup
    .string()
    .required()
    .oneOf([CollectionType.Puzzle, CollectionType.ColoringGrid]),
  [UploadCollectionField.Name]: yup
    .string()
    .required(strings.createAccNameRequired)
    .trim()
    .min(3, 'Must have atleast 3 characters!')
    .max(50, 'Cant have more than 50 characters!')
    .test(
      'mustContainOnly',
      "Must contain only uppercase, lowercase letters, numbers, space and special characters('-)",
      (value) => {
        const match = value?.match?.(/[a-zA-Z 0-9'-]*/)?.[0];
        return Boolean(match && match?.length === value.length);
      },
    )
    .test('uniqueName', 'Name must be unique', async (value, context) => {
      const collectionName =
        context.parent.type === 'coloring-grid' ? 'coloringGridCollections' : 'collections';

      const existsAlready = await getDocs(
        query(collection(firestore, collectionName), where('name', '==', value.trim())),
      );
      return Boolean(existsAlready.empty);
    }),
  [UploadCollectionField.Keywords]: yup.string().when('type', {
    is: (type: string) => type === CollectionType.Puzzle,
    then: (schema) => schema.trim().required(strings.collectionKeywordsRequired),
  }),
  [UploadCollectionField.AdminOnly]: yup.boolean(),
});
